import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReviewRmsRecordOfReviewComponent } from '../../../../components/review-content/review-rms-record-of-review/review-rms-record-of-review.component';

@Component({
  selector: 'rms-review-submission',
  standalone: true,
  imports: [
    CommonModule,
    ReviewRmsRecordOfReviewComponent
  ],
  templateUrl: './rms-review-submission.component.html',
  styleUrl: './rms-review-submission.component.css'
})
export class RmsReviewSubmissionComponent implements OnInit {

  @Input() rmsRecordReviewData: any;
  @Output() onSaveSection4 = new EventEmitter<any>();

  currentCaseId: string | null = null;

  ngOnInit(): void {
    if (this.rmsRecordReviewData) {
      this.currentCaseId = this.rmsRecordReviewData.case_id;
    }
  }

  submitRMSRecordReview(): void {
    this.onSaveSection4.emit({});
  }

}
